import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import classNames from 'classnames';

const TextInput = React.forwardRef(
    (
        {
            value,
            maxLength,
            minLength,
            minRows,
            hideCharsLeft,
            icon,
            placeholder,
            onChange,
            iconClick,
            disabled,
            disableEnter,
            handleSubmit,
            handleCancel,
            inputRef,
            InputProps,
            inputProps,
            ...standardMuiProps
        },
        ref,
    ) => {
        const charsLeft = maxLength - value.length;
        const inputDisabled = disabled === true;
        const containerClasses = classNames('wcf-ui-text-input-container', standardMuiProps.className);

        const handleKeyDown = (e) => {
            if (e.keyCode === 13) {
                // enter
                e.preventDefault();
                handleSubmit && handleSubmit();
            }

            if (e.keyCode === 27) {
                // escape
                handleCancel && handleCancel();
            }
        };

        const { buttonDataTestId, ...filteredMuiProps } = standardMuiProps;

        return (
            <TextField
                ref={ref}
                {...filteredMuiProps}
                className={containerClasses}
                value={value}
                onChange={onChange}
                disabled={inputDisabled}
                minRows={minRows}
                InputProps={{
                    ...InputProps,
                    endAdornment: (
                        <InputAdornment position="end">
                            {maxLength && !hideCharsLeft && charsLeft}
                            {icon && (
                                <IconButton
                                    onClick={iconClick}
                                    {...(standardMuiProps.buttonDataTestId
                                        ? { 'data-test-id': standardMuiProps.buttonDataTestId }
                                        : {})}
                                >
                                    <span className={`stw-${icon}`} />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                }}
                placeholder={placeholder}
                inputRef={inputRef}
                inputProps={{
                    ...inputProps,
                    maxLength,
                    minLength,
                    disabled: inputDisabled,
                    onKeyDown: handleKeyDown,
                }}
            />
        );
    },
);

export default TextInput;
